function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

import config from './amp-config.js';
import axios from './axios.js';
import log from './log.js';
import { missingConfig } from './errors.js';

var GatewayService = /*#__PURE__*/function () {
  function GatewayService(serviceName) {
    _classCallCheck(this, GatewayService);

    this.serviceName = serviceName;
  }

  _createClass(GatewayService, [{
    key: "get",
    value: function get(path, axiosConfig) {
      var _this = this;

      return config.get('gateway').then(function (gatewayUrl) {
        if (!gatewayUrl) {
          return Promise.reject(missingConfig('gateway'));
        }

        var url = "".concat(gatewayUrl, "/").concat(_this.serviceName, "/").concat(path);
        return axios.get(url, axiosConfig).then(function (res) {
          return res.data;
        });
      })["catch"](function (err) {
        log.error("Service \"".concat(_this.serviceName, "\" failed to GET. ").concat(err));
        throw err;
      });
    }
  }, {
    key: "getWithHeaders",
    value: function getWithHeaders(path, axiosConfig) {
      var _this2 = this;

      return config.get('gateway').then(function (gatewayUrl) {
        if (!gatewayUrl) {
          return Promise.reject(missingConfig('gateway'));
        }

        var url = "".concat(gatewayUrl, "/").concat(_this2.serviceName, "/").concat(path);
        return axios.get(url, axiosConfig).then(function (res) {
          return {
            data: res.data,
            headers: res.headers
          };
        });
      })["catch"](function (err) {
        log.error("Service \"".concat(_this2.serviceName, "\" failed to GET. ").concat(err));
        throw err;
      });
    }
  }, {
    key: "post",
    value: function post(path, data, axiosConfig) {
      var _this3 = this;

      return config.get('gateway').then(function (gatewayUrl) {
        if (!gatewayUrl) {
          return Promise.reject(missingConfig('gateway'));
        }

        var url = "".concat(gatewayUrl, "/").concat(_this3.serviceName, "/").concat(path);
        return axios.post(url, data, axiosConfig).then(function (res) {
          return res.data;
        });
      })["catch"](function (err) {
        log.error("Service \"".concat(_this3.serviceName, "\" failed to POST. ").concat(err));
        throw err;
      });
    }
  }, {
    key: "postWithHeaders",
    value: function postWithHeaders(path, data, axiosConfig) {
      var _this4 = this;

      return config.get('gateway').then(function (gatewayUrl) {
        if (!gatewayUrl) {
          return Promise.reject(missingConfig('gateway'));
        }

        var url = "".concat(gatewayUrl, "/").concat(_this4.serviceName, "/").concat(path);
        return axios.post(url, data, axiosConfig).then(function (res) {
          return {
            data: res.data,
            headers: res.headers
          };
        });
      })["catch"](function (err) {
        log.error("Service \"".concat(_this4.serviceName, "\" failed to POST. ").concat(err));
        throw err;
      });
    }
  }, {
    key: "put",
    value: function put(path, data, axiosConfig) {
      var _this5 = this;

      return config.get('gateway').then(function (gatewayUrl) {
        if (!gatewayUrl) {
          return Promise.reject(missingConfig('gateway'));
        }

        var url = "".concat(gatewayUrl, "/").concat(_this5.serviceName, "/").concat(path);
        return axios.put(url, data, axiosConfig).then(function (res) {
          return res.data;
        });
      })["catch"](function (err) {
        log.error("Service \"".concat(_this5.serviceName, "\" failed to PUT. ").concat(err));
        throw err;
      });
    }
  }, {
    key: "delete",
    value: function _delete(path, axiosConfig) {
      var _this6 = this;

      return config.get('gateway').then(function (gatewayUrl) {
        if (!gatewayUrl) {
          return Promise.reject(missingConfig('gateway'));
        }

        var url = "".concat(gatewayUrl, "/").concat(_this6.serviceName, "/").concat(path);
        return axios["delete"](url, axiosConfig).then(function (res) {
          return res.data;
        });
      })["catch"](function (err) {
        log.error("Service \"".concat(_this6.serviceName, "\" failed to DELETE. ").concat(err));
        throw err;
      });
    }
  }, {
    key: "head",
    value: function head(path, axiosConfig) {
      var _this7 = this;

      return config.get('gateway').then(function (gatewayUrl) {
        if (!gatewayUrl) {
          return Promise.reject(missingConfig('gateway'));
        }

        var url = "".concat(gatewayUrl, "/").concat(_this7.serviceName, "/").concat(path);
        return axios.head(url, axiosConfig).then(function (res) {
          return res.data;
        });
      })["catch"](function (err) {
        log.error("Service \"".concat(_this7.serviceName, "\" failed to HEAD. ").concat(err));
        throw err;
      });
    }
  }]);

  return GatewayService;
}();

export default GatewayService;